enum Color {
  Grey = "#E6E7EA",
  DarkGrey = "#878A91",
  Blue = "rgb(0, 45, 161)",
  Magenta = "#C33BC6",
  Error = "darkred",
}

export default Color;
